export const CommentsScopeService = Symbol('CommentsScopeService');
